export default __webpack_public_path__ + "static/analyze-8f16f25f1c742bf6a434c4a536b9240d.webp";